import { Component } from '@angular/core';
import { NavController, Events, IonicPage } from 'ionic-angular';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CrudProvider } from '../../providers/crud/crud';

@IonicPage()
@Component({
  selector: 'page-cabsand-dashboard',
  templateUrl: 'cabsand-dashboard.html',
})
export class CabsandDashboardPage {
  selectedTab: any = "service"
  serviceList: any = [];
  regoList: any = [];
  fireList: any = [];
  constructor(public navCtrl: NavController, public utility: UtiltiyProvider, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
  }

  ionViewDidLoad() {
    this.getMetaData();
  }

  segmentChanged(event) {
    console.log("event is ", event)

  }


  async getMetaData() {
    this.utiltiy.startLoading();
    this.serviceList = await this.getServiceData();
    this.regoList = await this.getData("get_rego_warning_list");
    this.fireList = await this.getData("fire_suppression_list");
    this.utiltiy.stopLoading();
  }

  async getServiceData() {
    return this.api.get("/tansix_prestart/Mobile_Dashboard/Mobile_Dashboard", false)
      .then((result: any) => {
        console.log("result", result);
        if (result.status) {
          result.result.forEach(element => {
            element.code = 0;
            if (element.vehicle_category == "1" || element.vehicle_category == "4") {
              if (parseFloat(element.current_hrs) >= parseFloat(element.hrs_service_due)) {
                element.code = 1;
              } else {
                element.code = 2;
              }
            }

            if (element.vehicle_category == "2" || element.vehicle_category == "3") {
              if (parseFloat(element.current_kms) >= parseFloat(element.kms_service_due)) {
                element.code = 1;
              } else {
                element.code = 2;
              }
            }

          });
          return result.result;
        } else {
          return [];
        }
      }, err => {
        this.utiltiy.stopLoading();
        return [];
      })

  }

  dateInPast = (firstDate, secondDate) =>
    firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0);
  async getData(method) {
    let formData: FormData = new FormData();
    formData.append("method_name", method);
    return this.api.post("/tansix_prestart/Mobile_Dashboard/Mobile_Dashboard", false, formData)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
          if (method == "fire_suppression_list") {
            result.result.forEach(element => {
              let code = 3;
              if (element.suppression_due.length != 0) {
                var dueDate = new Date(element.suppression_due) as any;
                var today = new Date() as any;
                let status = this.dateInPast(dueDate, today);
                const diffTime = Math.abs(dueDate - today);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                if (status) {
                  code = 1;
                } else {
                  if (diffDays <= 30) {
                    code = 2;
                  } else {
                    code = 0;
                  }
                }
              }

              element.code = code;
            });
          }

          return result.result;
        } else {
          return [];
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })

  }




}



// WEBPACK FOOTER //
// ./src/pages/cabsand-dashboard/cabsand-dashboard.ts